define( function() {
	"use strict";

	return ( /^margin/ );
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/css/var/rmargin.js
// module id = 443
// module chunks = 17 22 23